import axios from '../utils/axios';
import qs from 'qs';

/**
 * 获取单位信息
 * @param params
 * @returns {*}
 */
export async function getOrg(params) {

  return await axios.GET('/v1/profile/org', params);
}

/**
 * 修改密码
 * @param params
 * @returns {*}
 */
export async function upOrgPassword(params) {

  return await axios.POST(`/v1/org/password?` + qs.stringify(params));
}

/**
 * 获取单位列表
 * @param params
 * @returns {*}
 */
export async function getOrgsList(params) {

  return await axios.GET('/v1/agent/orgs', params);
}

/**
 * 获取单位列表
 * @param params
 * @returns {*}
 */
export async function getOrgsDetail(params) {

  return await axios.GET('/v1/org/info', params);
}

/**
 * 删除单位
 * @param params
 * @returns {*}
 */
export async function deletingUnit(params) {

  return await axios.POST(`/v1/org/deletingUnit?` + qs.stringify(params));
}

/**
 * 绑定平台开关
 * @param params
 * @returns {*}
 */
export async function setBindingPlatform(params) {

  return await axios.POST(`/v1/org/setBindingPlatform?` + qs.stringify(params));
}


/**
 * 更新按钮
 * @param params
 * @returns {*}
 */
export async function updateUnit(params) {

  return await axios.POST(`/v1/org/updateUnit?` + qs.stringify(params));
}


/**
 * 查询区域节点数据
 * @param params
 * @returns {*}
 */
export async function getRegion(params) {

  return await axios.GET('/v1/org/getRegion', params);
}


/**
 * 添加单位
 * @param params
 * @returns {*}
 */
export async function addOrg(params) {

  return await axios.POST(`/v1/org/add?` + qs.stringify(params));
}


/**
 * 获取单位登录地址
 * @param params
 * @returns {*}
 */
export async function getAssemblyUrl(params) {

  return await axios.GET('/v1/org/getAssemblyUrl', params);
}


/**
 * 修改区域提出单独接口
 * @param params
 * @returns {*}
 */
export async function updateRegion(params) {

  return await axios.POST(`/v1/org/updateRegion?` + qs.stringify(params));
}
